export class LinguaDTO {
  id: string;
  codice: string;
  nome: string;
}
